import React from "react";
import {
  doctors,
  drShamim,
  leaf,
  subDoc1,
  subDoc2,
  mainLeaf,
  flower,
  leaf2,
  subDoc4,
  subDoc5,
  subDoc6,
  subDoc8,
  subDoc7,
  subDoc3,
} from "../../assets";
import { Link } from "react-router-dom";
import { AiOutlineCaretRight } from "react-icons/ai";
import DoctorCard from "../../Components/DoctorCard";
import { motion } from "framer-motion";
import { LazyLoadImage } from "react-lazy-load-image-component";

const Specialists = ({ setSingleDoc }) => {
  return (
    <div id="specialists">
      <img src={mainLeaf} alt="" className="mainLeaf" />
      <img src={flower} alt="" className="mainLeaf2" />
      <img src={leaf2} alt="" className="mainLeaf3" />
      <img src={mainLeaf} alt="" className="mainLeaf4" />

      <motion.div
        className="topBanner"
        whileInView={{ opacity: [0, 1], y: [30, 0] }}
        transition={{ duration: 0.7 }}
      >
        <img src={doctors} alt="" className="docs" />
      </motion.div>

      <div className="doctors">
        <motion.div
          className="mainDoc"
          whileInView={{ opacity: [0, 1], y: [30, 0] }}
          transition={{ duration: 0.7 }}
        >
          <div className="left">
            <small>American Board Certified Aesthetic Dermatologist</small>
            <h1>DR. SARKER MAHBUB AHMED SHAMIM</h1>

            <div className="education">
              <h2>Education</h2>
              <p>MBBS, Dip. Derm (Glasgow, UK)</p>
              <p>
                Diploma in Aesthetic Medicine (USA), MCPS, FCPS (Dermatology)
              </p>
            </div>

            <div className="exp">
              <h2>20+ years of Exeperience</h2>
            </div>
          </div>

          <LazyLoadImage
            effect="blur"
            src={drShamim}
            alt=""
            className="middle"
          />

          <div className="right">
            <img src={leaf} alt="" />
            <div className="area">
              <h1>ADVANCE TRANING IN</h1>
              <p>
                <span>MD Codes</span> - Allergan Medical Institute
              </p>
              <p>
                <span>Body Shaping</span> - USA, Germany, Italy & UAE
              </p>
              <p>
                <span>Botox, Filler & Mesotherapy</span> - USA, Italy, Singapore
                & UAE
              </p>
              <p>
                <span>Hair Transplant</span> - USA
              </p>
              <p>
                <span>Whitening & Mesotherapy</span> - Spain
              </p>
              <p>
                <span>Cosmetic Surgery</span> - USA, UAE & Thailand
              </p>
              <p>
                <span>Sclerotherapy</span> - USA
              </p>
              <p>
                <span>Phototherapy</span> - Germany, UK, Singapore
              </p>
              <p>
                <span>Aesthetic Laser</span> - USA, Russia, Germany, UK, Italy,
                France, Turkey, Vienna, Singapore, Thailand, Korea, UAE,
                Pakistan, Malaysia
              </p>
            </div>

            <Link to="/chief-specialist" className="linkTo">
              Details <AiOutlineCaretRight className="rightArrow" />
            </Link>
          </div>
        </motion.div>
        <motion.div
          className="subDocs"
          whileInView={{ opacity: [0, 1], y: [30, 0] }}
          transition={{ duration: 0.7 }}
        >
          <div className="titleBar">
            <h2>Our Related Specialists</h2>
            <p>We take care of you</p>
          </div>

          <div className="sub-doctors">
            <DoctorCard
              doc={subDoc1}
              name="Dr. Dilruba Sharmin"
              edu="American Academy of Aesthetic Medicine (USA)"
              spe="Aesthetic Dermatologist And Laser Specialist"
              setSingleDoc={setSingleDoc}
              exp="2"
              desc1="She has wide experience in Aesthetic Dermatology and Laser Surgery more than 5 year.
                Her subspecialty of interest include laser, Dermatological Surgery. Cosmetic Dermatology, PRP. She regularly consult Acne, Melasma, Psoriasis, Eczema.
                She is a member of American Academy of Aesthetic Medicine (USA)
                She graduated from holy Family Medical College."
              desc2="She later Completed her post-graduation training in dermatology & venereology from. Shaheed Suhrawardy Medical College Hospital."
              highlight="Consultant of Laser Treat & Dhaka Dermatology Institute"
              sp1="Dermatological Surgery"
              sp2="Cosmetic Dermatology"
              sp3="PRP"
            />

            <DoctorCard
              doc={subDoc2}
              name="Dr. Rabeya Afroz Shoma"
              edu="MBBS, DDV (BSMMU)"
              spe="Skin, Sex & Anti-aging Specialist, Laser & Cosmetic Surgeon"
              setSingleDoc={setSingleDoc}
              exp="8"
              desc1="Dr. Rabeya Afroz Shoma has got her MBBS from Cumilla Medical College. She obtained her DDV from BSMMU in the year 2014.
                Dr. Rabeya has got vast experience in the management of general & aesthetic dermatology. She is been with Dr. Shamim & laser treat for the last 6 years. She has completed aesthetic training from American Academy of Aesthetic Medicine (AAAM)
                Besides these she has also attended many national & international conferences of dermatology & Aesthetic Medicine.
                "
              desc2="She strives to provide the most advanced & personalized care to all her patients.
                Special Interest: BOTOX, FILLER, PRP, Vitiligo Surgery, Treating Scars, Hair Loss, Pigmentation, Genital & Vulvar Itching, Vulvar Tightening, Sex Counselling, O-Shot, P-Shot"
              adSub="Laser"
              adLoc="USA, Thailand, India"
              highlight="Core Member"
              sp1="Skin"
              sp2="Sex & Anti-aging"
              sp3="Laser & Cosmetic"
            />

            <DoctorCard
              doc={subDoc3}
              name="Dr. Salma Sumi"
              edu="BSC, MSC (Food & Nutrition)"
              spe="Body Shaping & Weight management of Laser Treat"
              setSingleDoc={setSingleDoc}
              exp="5"
              desc1="Ms. Salma Sumi has got her B.Sc (Hons) in Food & Nutrition from College of Home Economics, University of Dhaka in 2012. She obtained her M.Sc from University of Dhaka in the year 2015.
                Ms. Salma Sumi has got more than 4 years’ experience in Nutrition & Dietetics. In 2015, she attended in-patient & out-patient departments during her training period In BSMMU & BIRDEM General Hospital. She has Advanced training in “Dietetics & Nutrition Therapy”. 
                "
              desc2="She worked as a Trainee Dietitian in United Hospital Limited, Dhaka. Besides these she has also taken part in various Nutrition & Dietetics programs.
                Special Interest: CoolSculpting, Zerona, Proslimelt, CLATUU, Lipolytic Mesotherapy
                As an experienced Nutritionist and body Shaping Consultant, Ms. Salma Sumi will guide you expertly through your Body shaping Journey."
              sp1="Body Shaping"
              sp2="Weight management"
            />

            <DoctorCard
              doc={subDoc4}
              name="Dr. Saymun Jesmin"
              edu="American Academy of Aesthetic Medicine (USA)"
              spe="Aesthetic Dermatologist And Laser Specialist"
              setSingleDoc={setSingleDoc}
              exp="2"
              desc1="Dr. Saymun Jesmin attained her MBBS degree from Mymensingh Medical College in 2008.She went on to pursue her post-graduation training in Dermatology and Internal medicine. In 2014, she passed FCPS part-1.She had completed advanced aesthetic training from American Academy of Aesthetic Medicine (USA).
                Dr. Saymun has more than 9 years of experience in aesthetic medicine.
                She believes in providing quality treatment tailored to individual requirements."
              desc2="Special Interest: Acne, Long Pulsed Nd:YAG Laser, Chemical Peeling, CO2 Laser, PRP, Q-Switched Nd:YAG Laser, HIFU, NBUVB, Hydra facial, IPL, Subcision, Body Shaping etc"
              sp1="Acne"
              sp2="Chemical Peeling"
              sp3="Hydra facial"
            />
            <DoctorCard
              doc={subDoc5}
              name="Dr. Shamma Binte Hafiz"
              edu="American Academy of Aesthetic Medicine (USA)"
              spe="Aesthetic Dermatologist And Laser Specialist"
              setSingleDoc={setSingleDoc}
              exp="5"
              desc1="Dr. Shamma Binte Hafiz Heeya attained her MBBS degree from Delta Medical College in 2013.
                She is been with Dr. Shamim & Laser Treat for the last 5yrs. She has attended over 5000 patients during her training period. She has taken part in various CME programs.
                She believes in providing quality treatment tailored to individual requirements."
              desc2="Special Interest: Vitiligo Surgery, PRP, Treating Scars, Hair Loss, Pigmentation, Acne Treatment, Long Pulsed Nd:YAG Laser, Chemical Peeling, CO2 Laser, Q-Switched Nd:YAG Laser, HIFU, NBUVB"
              sp1="Vitiligo Surgery"
              sp2="Treating Scars"
              sp3="Hair Loss"
            />
            <DoctorCard
              doc={subDoc6}
              name="Dr. Shumana Sharmin"
              edu="MBBS, DDV (BSMMU)"
              spe="Skin, Sex & Anti-aging Specialist, Laser & Cosmetic Surgeon"
              setSingleDoc={setSingleDoc}
              exp="8"
              desc1="Dr. Shumana Sharmin, who is a specialist dermatologist, cosmetologist & venereologist has passed out from holy family Red Crescent medical college hospital, Dhaka in year 2006. After that she took training in dermatology & venereology in different government hospitals in Bangladesh.
                In 2012 she pursued her post-graduation degree, DDV (Diploma in Dermatology & Venereology). She also took advance training in Aesthetic Medicine under American Academy of Aesthetic Medicine in 2019."
              desc2="She has an expertise in a variety of dermatological & cosmetic procedures including Chemical Peeling, Laser Hair Removal, CO2 Laser, Meso Therapy, Tattoo Removal, PRP, Fractional Laser, Subcision, IPL, HIFU, Hydrafacial etc.
                She has also attended some national & international conferences of dermatology & cosmetology."
              sp1="Skin"
              sp2="Sex & Anti-aging"
              sp3="Laser & Cosmetic"
            />
            <DoctorCard
              doc={subDoc7}
              name="Dr. Sonia Sharmin"
              edu="American Academy of Aesthetic Medicine (USA)"
              spe="Aesthetic Dermatologist And Laser Specialist"
              setSingleDoc={setSingleDoc}
              exp="2"
              desc1="Dr. Sonia Sharmin attained her MBBS degree from shaheed Monsur Ali Medical College and hospital in 2018. Post graduation training from DMC.
                She has been with Dr. Shamim & Laser Treat for the last 2yrs. She has attended over 5000 patients during her training period. She has taken part in various CME programs.
                She believes in providing quality treatment tailored to individual requirements."
              desc2="Special Interest: Vitiligo Surgery, PRP, Treating Scars, Hair Loss, Pigmentation, Acne Treatment, Long Pulsed Nd:YAG Laser, Chemical Peeling, CO2 Laser, Q-Switched Nd:YAG Laser, HIFU, NBUVB"
              sp1="Pigmentation"
              sp2="Hair Loss"
              sp3="Acne Treatment"
            />
            <DoctorCard
              doc={subDoc8}
              name="Dr. A.S.M Raquibul Islam Akash"
              edu="	American Academy of Aesthetic Medicine (USA)"
              spe="Aesthetic Dermatologist And Laser Specialist"
              setSingleDoc={setSingleDoc}
              exp="2"
              desc1="Dr. A.S.M.Raquibul islam akash attained his MBBS degree from Dhaka University in 2016.He went on to pursue his post-graduation training in Dermatology and Internal medicine. 
                Dr. A.S.M Raquibul islam akash has more than 3years’ experience in clinical dermatology. He has attended over 10,000 patients in the out-patient and in-patient departments during his training period. He has taken part in various CME programs.
                He believes in providing quality treatment tailored to individual requirements."
              desc2="Special Interest: Acne, Long Pulsed Nd:YAG Laser, Chemical Peeling, CO2 Laser, PRP, Q-Switched Nd:YAG Laser, HIFU, NBUVB"
              sp1="Acne"
              sp2="PRP"
              sp3="Chemical Peeling"
            />
          </div>
        </motion.div>
      </div>

      <motion.div
        className="doctors-video"
        whileInView={{ opacity: [0, 1], y: [50, 0] }}
        transition={{ duration: 0.7 }}
      >
        <iframe
          src="https://www.youtube.com/embed/i11TceowUT0"
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen={true}
        ></iframe>
      </motion.div>
    </div>
  );
};

export default Specialists;
